import { buildOAuthState } from '@crossbeam/utils';

import { WebAuth } from 'auth0-js';

import appConfig, { useStagingApi } from '@/config';
import { ls } from '@/local_storage';
import urls from '@/urls';
import { PREVIEW_BUILD_REGEX, isLoginPopup } from '@/utils';

export function buildRedirectUri() {
  if (isLoginPopup()) {
    return `https://${appConfig.host}/oauth-redirect`;
  }

  const origin = window.location.origin;

  const isPreview = PREVIEW_BUILD_REGEX.test(origin);
  const isDevHost = origin === 'https://app.crossbeam-dev.com';

  const redirectUrl = new URL(urls.session.callback, appConfig.apiBaseUrl);

  const shouldSetReturnTo = isPreview || (useStagingApi() && isDevHost);
  if (shouldSetReturnTo) {
    redirectUrl.searchParams.set('returnTo', origin);
  }

  return redirectUrl.toString();
}

export class AuthService {
  constructor() {
    this.auth0 = new WebAuth({
      ...appConfig.auth0,
      redirectUri: buildRedirectUri(),
      responseType: 'code',
      scope: 'openid profile email user_metadata',
    });
  }

  googleLogin(metadata = {}) {
    const { nonce, encodedState } = buildOAuthState(metadata);
    ls.oauthState.set(nonce);
    this.auth0.authorize({ connection: 'google-oauth2', state: encodedState });
  }

  ssoLogin(connection, metadata = {}) {
    const { nonce, encodedState } = buildOAuthState(metadata);
    ls.oauthState.set(nonce);
    this.auth0.authorize({ connection, state: encodedState });
  }

  basicLogin(email, password) {
    return new Promise((resolve, reject) => {
      this.auth0.login(
        {
          realm: 'Username-Password-Authentication',
          username: email,
          password,
        },
        (err, result) => {
          if (err) {
            return reject(err);
          }
          return resolve(result);
        },
      );
    });
  }
}

export default { AuthService };
